"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var types_1 = require("./types");
var filterSections = {
    DateFilterIndex: {
        type: 'custom_date_range',
        key: types_1.DateFilterIndex,
        order: -3,
        header: 'Show Last',
        value: 'status',
        selectionType: 'single_select',
        filters: [
            {
                order: 0,
                isSelected: false,
                name: '1 month',
                customDateFilterType: '1-month',
                customDateRangeStart: moment_timezone_1.default().subtract(1, 'months'),
                customDateRangeEnd: moment_timezone_1.default()
            },
            {
                order: 1,
                isSelected: false,
                name: '3 months',
                customDateFilterType: '3-months',
                customDateRangeStart: moment_timezone_1.default().subtract(3, 'months'),
                customDateRangeEnd: moment_timezone_1.default()
            },
            {
                order: 2,
                isSelected: false,
                name: '6 months',
                customDateFilterType: '6-months',
                customDateRangeStart: moment_timezone_1.default().subtract(6, 'months'),
                customDateRangeEnd: moment_timezone_1.default()
            },
            {
                order: 3,
                isSelected: false,
                name: '1 year',
                customDateFilterType: '1-year',
                customDateRangeStart: moment_timezone_1.default().subtract(1, 'year'),
                customDateRangeEnd: moment_timezone_1.default()
            },
            {
                order: 4,
                isSelected: false,
                name: 'custom date range',
                customDateFilterType: 'custom',
                customDateRangeStart: null,
                customDateRangeEnd: null
            }
        ]
    }
};
exports.default = filterSections;
//# sourceMappingURL=filters.js.map